export default {"src":"/_next/static/media/exclamationIcon.a6e299b1.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};